import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { CategoryRes, ReviewRes, ReviewReq } from '@/models/interface/review';

export class ReviewService extends ApiFactory {
  constructor() {
    super('MemberRecord');
  }

  fetchData(params: ReviewReq): Promise<ApiDataResponse<ReviewRes>> {
    return this.post('ReviewList', params);
  }

  fetchCategories(): Promise<ApiDataResponse<CategoryRes[]>> {
    return this.get('ReviewCategories');
  }
}
